module.exports = __webpack_public_path__ + "static/media/ur-PK.c2d11f56.md";